import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <h5 className="text-center text-black p-3 bg-light">
        © 2024 Copyright : <i className="text-danger fw-bold ">Wagdy Ashraf</i>
      </h5>
    );
  }
}
